import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { Menu, MenuItem } from './Menu';

const menuOptions = [
    ["ACCOMPLISHMENTS", "/~aesmith/"],
    ["HONORS AND AWARDS", "/~aesmith/honors"],
    ["PUBLICATIONS", "/~aesmith/publications"],
    ["RESEARCH FUNDING", "/~aesmith/research"],
    ["PROFESSIONAL ACTIVITIES", "/~aesmith/professional-activities"],
    ["GRADUATE STUDENTS", "/~aesmith/graduate-students"],
    ["VISITING SCHOLARS", "/~aesmith/visiting-scholars"]
];

const Header = () => {
    return (
        <div className="Header">
            <div className="header-logo">
                <div className="saira header-title"><Link to="/~aesmith/">ALICE E. SMITH</Link></div>
                <div className="roboto header-subtitle"><Link to="/~aesmith/">Auburn University</Link></div>
            </div>
            <div style={{textAlign: "right", verticalAlign: "top"}}>
            <Menu>
                {menuOptions.map(o => <MenuItem key={o[0]} path={o[1]}>{o[0]}</MenuItem>)}
                <li><a href="https://scholar.google.com/citations?user=3WhioLIAAAAJ&hl=en" target='_blank' rel="noreferrer">GOOGLE SCHOLAR</a></li>
            </Menu>
            </div>
        </div>
    )
}

export default Header;